import { createFileRoute } from "@tanstack/react-router";
import Profile from "@/features-root-user/settings/profile";

export const Route = createFileRoute("/_root/root-user/settings/profile")({
  component: Profile,
});
